export default __webpack_public_path__ + "static/media/1-html-css-java.5b936c04.png";